import { useEffect, useState } from 'react';
import * as S from 'pages/payments/threeds2/threeds2.styles';
import Spinner from 'components/spinner/spinner.component';
import { useSpreedlyCheckoutSdkScriptLoading } from 'components/payment/spreedly-checkout-sdk/spreedly-checkout-sdk-script-loading.hooks';

// The caller supplies the status handler rather than this component picking
// one for itself — a web checkout modal needs to redirect/close itself, a
// native hosted page needs to forward the event to the mobile app instead,
// and neither belongs here (docs §7: the new SDK's six callbacks share the
// legacy `3ds:status` event's six-action vocabulary, so either caller's
// existing handler works verbatim against them).
const ThreeDS2CheckoutSdk = ({
  environmentKey,
  transactionToken,
  onStatusUpdate,
}) => {
  const [loaded, setLoaded] = useState(false);

  const { loading, error } = useSpreedlyCheckoutSdkScriptLoading({
    onload: () => {
      setLoaded(true);
    },
  });

  useEffect(() => {
    if (!!error)
      throw new Error(`Spreedly script loading error: ${error.message}`);
  }, [error]);

  useEffect(() => {
    if (!transactionToken) throw new Error('Transaction token not set');
  }, [transactionToken]);

  useEffect(() => {
    if (!window.SpreedlyThreeDSLifecycle) return;

    const lifecycle = new window.SpreedlyThreeDSLifecycle({
      environmentKey: environmentKey,
      hiddenIframeLocation: 'device-fingerprint',
      challengeIframeLocation: 'challenge',
      transactionToken,
      challengeIframeClasses: 'challenge-iframe',
      // All six callbacks must point at the same handler — a missing one
      // silently strands the flow instead of throwing (docs §7).
      callbacks: {
        onChallenge: onStatusUpdate,
        onSuccess: onStatusUpdate,
        onError: onStatusUpdate,
        onDeviceFingerprint: onStatusUpdate,
        onTriggerCompletion: onStatusUpdate,
        onFinalizationTimeout: onStatusUpdate,
      },
    });

    lifecycle.start();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded]);

  return (
    <>
      {loading && <Spinner data-testid="ThreeDS2CheckoutSdk.Spinner" />}
      <S.HiddenDiv id="device-fingerprint" />
      <S.HiddenDiv id="challenge-modal">
        <div id="challenge"></div>
      </S.HiddenDiv>
    </>
  );
};

export default ThreeDS2CheckoutSdk;
